export enum TrackingEventName {
  PHOTOGRAPHER_PAGE_VIEW = 'PHOTOGRAPHER_PAGE_VIEW',
  PHOTOGRAPHER_SEARCH_IMPRESSION = 'PHOTOGRAPHER_SEARCH_IMPRESSION',
  PHOTOGRAPHER_PAGE_BOOK_NOW_CLICK = 'PHOTOGRAPHER_PAGE_BOOK_NOW_CLICK',
  PHOTOGRAPHER_MODAL_SERVICE_SELECTED = 'PHOTOGRAPHER_MODAL_SERVICE_SELECTED',
  PHOTOGRAPHER_MODAL_TIMESLOT_SELECTED = 'PHOTOGRAPHER_MODAL_TIMESLOT_SELECTED',
  PHOTOGRAPHER_MODAL_DETAILS_SUBMITTED = 'PHOTOGRAPHER_MODAL_DETAILS_SUBMITTED',
  SERVICE_PAGE_VIEW = 'SERVICE_PAGE_VIEW',
  SERVICE_PAGE_IMAGES_VIEWED = 'SERVICE_PAGE_IMAGES_VIEWED',
  SERVICE_PAGE_TIMESLOT_SELECTED = 'SERVICE_PAGE_TIMESLOT_SELECTED',
  SERVICE_PAGE_DETAILS_SUBMITTED = 'SERVICE_PAGE_DETAILS_SUBMITTED',
  CHECKOUT_STARTED = 'CHECKOUT_STARTED',
  CHECKOUT_SUCCEEDED = 'CHECKOUT_SUCCEEDED',
  CHECKOUT_CANCELLED = 'CHECKOUT_CANCELLED',
}

export interface PhotographerPageViewPayload {
  photographer_id: number;
  photographer_slug: string;
  city?: string | null;
  services_count?: number | null;
  tags?: string[] | null;
}

export interface PhotographerSearchImpressionPayload {
  photographer_id: number;
  photographer_slug: string;
  position?: number | null;
  city?: string | null;
  tags?: string[] | null;
  source?: string | null;
}

export interface PhotographerPageBookNowClickPayload {
  photographer_id: number;
  photographer_slug: string;
  services_count?: number | null;
}

export interface PhotographerModalServiceSelectedPayload {
  service_id: number;
  service_name: string;
  photographer_id: number;
  photographer_slug: string;
  source: string;
}

export interface PhotographerModalTimeslotSelectedPayload {
  service_id: number;
  service_name: string;
  photographer_id: number;
  photographer_slug: string;
  datetime: string;
  source: string;
}

export interface PhotographerModalDetailsSubmittedPayload {
  service_id: number;
  service_name: string;
  photographer_id: number;
  photographer_slug: string;
  datetime: string;
  price: number | null;
  payment_mode: 'full' | 'deposit';
  deposit_percentage: number | null;
  currency: string;
  source: string;
}

export interface ServicePageViewPayload {
  service_id: number;
  service_name: string;
  photographer_slug: string;
  price_mode: 'range' | 'fixed';
  deposit_available: boolean;
}

export interface ServicePageImagesViewedPayload {
  service_id: number;
  service_name: string;
  photographer_slug: string;
  images_count: number;
}

export interface ServicePageTimeslotSelectedPayload {
  service_id: number;
  service_name: string;
  photographer_slug: string;
  datetime: string;
}

export interface ServicePageDetailsSubmittedPayload {
  service_id: number;
  service_name: string;
  photographer_slug: string;
  datetime: string;
  price: number | null;
  payment_mode: 'full' | 'deposit';
  deposit_percentage: number | null;
  currency: string;
}

export interface CheckoutStartedPayload {
  service_id: number;
  service_name: string;
  photographer_slug: string;
  datetime: string;
  price: number | null;
  payment_mode: 'full' | 'deposit';
  deposit_percentage: number | null;
  currency: string;
  source?: string | null;
  photographer_id?: number | null;
}

export interface CheckoutCompletedPayload {
  booking_id: number;
  service_id: number;
  service_name?: string | null;
  amount: number | null;
  currency: string;
  discount?: number | null;
  deposit_amount?: number | null;
  status: string;
}

export type TrackingPayloadMap = {
  [TrackingEventName.PHOTOGRAPHER_PAGE_VIEW]: PhotographerPageViewPayload;
  [TrackingEventName.PHOTOGRAPHER_SEARCH_IMPRESSION]: PhotographerSearchImpressionPayload;
  [TrackingEventName.PHOTOGRAPHER_PAGE_BOOK_NOW_CLICK]: PhotographerPageBookNowClickPayload;
  [TrackingEventName.PHOTOGRAPHER_MODAL_SERVICE_SELECTED]: PhotographerModalServiceSelectedPayload;
  [TrackingEventName.PHOTOGRAPHER_MODAL_TIMESLOT_SELECTED]: PhotographerModalTimeslotSelectedPayload;
  [TrackingEventName.PHOTOGRAPHER_MODAL_DETAILS_SUBMITTED]: PhotographerModalDetailsSubmittedPayload;
  [TrackingEventName.SERVICE_PAGE_VIEW]: ServicePageViewPayload;
  [TrackingEventName.SERVICE_PAGE_IMAGES_VIEWED]: ServicePageImagesViewedPayload;
  [TrackingEventName.SERVICE_PAGE_TIMESLOT_SELECTED]: ServicePageTimeslotSelectedPayload;
  [TrackingEventName.SERVICE_PAGE_DETAILS_SUBMITTED]: ServicePageDetailsSubmittedPayload;
  [TrackingEventName.CHECKOUT_STARTED]: CheckoutStartedPayload;
  [TrackingEventName.CHECKOUT_SUCCEEDED]: CheckoutCompletedPayload;
  [TrackingEventName.CHECKOUT_CANCELLED]: CheckoutCompletedPayload;
};

export interface TrackingEventPayload<K extends TrackingEventName = TrackingEventName> {
  name: K;
  flow?: string | null;
  trackingId?: string | null;
  occurredAt?: string | null;
  idempotencyKey?: string | null;
  payload?: TrackingPayloadMap[K] | null;
}

export interface TrackingEventGrouped {
  name: TrackingEventName;
  flow?: string | null;
  count: number;
}
